import _ from 'lodash';
import React from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link, withRouter } from 'react-router-dom';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledButtonDropdown,
} from 'reactstrap';

import addNotification from '../../../../components/notification';
import Table from '../../../../components/table/Table';
import FormatHelpers from '../../../../helpers/format';

import ROUTES from '../../../../config/routes';

import { deleteCustomer, getCustomersList } from '../../../../app/store/actions/customers';

class CustomerList extends React.Component {
  static filterColumn = ({ onChange }) => (
    <input
      type="text"
      style={{ width: '100%' }}
      onKeyPress={(event) => {
        if (event.keyCode === 13 || event.which === 13) {
          onChange(event.target.value);
        }
      }}
      onKeyUp={(event) => {
        if (event.target.value === '' && (event.keyCode === 8 || event.which === 8)) {
          onChange(event.target.value);
        }
      }}
    />
  );

  constructor(props) {
    super(props);

    this.page = 0;
    this.pageSize = 10;
    this.sorted = [];
    this.filtered = [];

    this.state = {
      showModalDelete: false,
      customerUpdate: null,
      pages: 0,
      totalDataLength: 0,
    };

    this.defaultSorted = [
      {
        id: 'code',
        desc: false,
      },
    ];

    this.tableColumns = [
      {
        Header: I18n.t('BEE55' /* Ações */),
        accessor: 'action',
        style: { overflow: 'visible', alignSelf: 'center' },
        filterable: false,
        sortable: false,
        width: 100,
        Cell: (rows) => (
          <div style={{ textAlign: 'center' }}>
            <button type="button" className="btn btn-default btn-xs">{I18n.t('BEE55' /* Ações */)}</button>
            <UncontrolledButtonDropdown>
              <DropdownToggle color="default" caret className="btn-xs" />
              <DropdownMenu>
                <DropdownItem onClick={() => this.showCustomerDetail(rows.row)}>
                  {I18n.t('BEE56' /* Detalhes */)}
                </DropdownItem>
                <DropdownItem onClick={() => this.showEditCustomer(rows.row)}>
                  {I18n.t('BEE57' /* Editar */)}

                </DropdownItem>
                {!this.props.formIntegrations && (
                <DropdownItem onClick={() => this.showCopyCustomer(rows.row)}>
                  {I18n.t('BEE80' /* Copiar */)}

                </DropdownItem>
                )}
                {!this.props.formIntegrations && (
                  // eslint-disable-next-line max-len
                  <DropdownItem onClick={() => this.showDeleteCustomer(rows.row)}>{I18n.t('BEE81' /* Eliminar */)}</DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledButtonDropdown>
          </div>
        ),
      }, {
        Header: I18n.t('BEE82' /* Código */),
        accessor: 'code',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE84' /* Razão Social */),
        accessor: 'name',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 400,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE352' /* Nome Fantasia */),
        accessor: 'businessName',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE4214' /* CPF / CNPJ */),
        accessor: 'cnpj',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Cell: (row) => (
          <span>{FormatHelpers.formatCpfOrCnpj(row.value)}</span>
        ),
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE86' /* E-mail */),
        accessor: 'email',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 200,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE133' /* Telefone */),
        accessor: 'phone',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 150,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE119' /* CEP */),
        accessor: 'postalCode',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE53' /* Cidade */),
        accessor: 'city',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: CustomerList.filterColumn,
      }, {
        Header: I18n.t('BEE87' /* Estado */),
        accessor: 'state',
        style: { alignSelf: 'center', textAlign: 'center' },
        minWidth: 100,
        Filter: CustomerList.filterColumn,
      },
    ];
  }

  componentDidMount() {
    this.maintainsState();
  }

  maintainsState = async () => {
    if (this.props.location.state && this.props.location.state.dice) {
      this.setState({
        page: this.props.location.state.dice.page,
        firstRun: true,
      });
    }
  };

  setInitState = () => {
    this.setState({
      showModalDelete: false,
      customerUpdate: null,
    });
  };

  getCustomers = async () => {
    const data = await this.props.getCustomersList({
      page: this.page,
      pageSize: this.pageSize,
      sorted: this.sorted,
      filtered: this.filtered,
    });

    this.setState({ pages: data.pages, totalDataLength: data.totalDataLength });
  };

  deleteCustomer = async (customer) => {
    try {
      const result = await this.props.deleteCustomer(customer._original.id);

      if (result) {
        addNotification(
          'success',
          I18n.t('BEE311' /* Eliminar Cliente */),
          I18n.t('BEE3267', { 0: customer.code } /* Cliente %{0} excluído com sucesso! */),
          'top-right',
        );
      }
      await this.getCustomers();
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE311' /* Eliminar Cliente */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE311' /* Eliminar Cliente */),
            I18n.t('BEE4228' /* Ocorreu um erro ao deletar o cliente */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE311' /* Eliminar Cliente */),
          I18n.t('BEE4228' /* Ocorreu um erro ao deletar o cliente */),
          'top-right',
        );
      }
    }
    this.setInitState();
  };

  showCustomerDetail = (customer) => {
    this.props.history.push({
      pathname: ROUTES.CUSTOMER_DETAIL,
      state: {
        customer: customer._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showEditCustomer = (customer) => {
    this.props.history.push({
      pathname: ROUTES.CUSTOMER_EDIT,
      state: {
        customer: customer._original,
      },
      dice: {
        page: this.state.page,
      },
    });
  };

  showCopyCustomer = (customer) => {
    this.props.history.push({
      pathname: ROUTES.CUSTOMER_COPY,
      state: {
        customer: customer._original,
      },
    });
  };

  showDeleteCustomer = (customer) => {
    this.setState({ showModalDelete: true, customerUpdate: customer });
  };

  render() {
    const {
      customerUpdate, showModalDelete, pages, page, totalDataLength,
    } = this.state;
    const { customersList = [] } = this.props;
    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1389' /* Cadastros */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE14' /* Gerais */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE22' /* Clientes */)}</li>
          </ol>
        </div>
        <Table
          downloadCSV
          wikiHelp={ROUTES.CUSTOMER_HELP}
          headerTitle={I18n.t('BEE22' /* Clientes */)}
          actionButtons={!this.props.formIntegrations && (
            <div className="ml-auto">
              <Link to={ROUTES.CUSTOMER_CREATE} className="btn btn-success btn-sm btn-rounded pl-2 pr-3">
                <i className="fa fa-plus mr-1" />
                {' '}
                {I18n.t('BEE313' /* Incluir Cliente */)}
              </Link>
            </div>
          )}
          panelHeaderProps={{
            onClickReload: this.getCustomers,
          }}
          filterable
          data={customersList}
          totalDataLength={totalDataLength}
          columns={this.tableColumns}
          expander
          defaultPageSize={10}
          defaultSorted={this.defaultSorted}
          defaultFilterMethod={(filter, row) => {
            const input = _.lowerCase(filter.value);
            const value = _.lowerCase(row[filter.id]);
            if (_.includes(value, input)) {
              return true;
            }
          }}
          manual
          pages={pages}
          page={(page)
            || ((!this.state.firstRun
              && this.props.location.state
              && this.props.location.state.dice
              && this.props.location.state.dice.page)
              ? this.props.location.state.dice.page : page)}
          onPageChange={(p) => ((p >= 0) ? this.setState({ page: p }) : this.setState({ page: 0 }))}
          onFetchData={(state) => {
            let pag;
            if (state.page) {
              pag = state.page;
            } else if (!this.state.firstRun
              && this.props.location.state
              && this.props.location.state.dice
              && this.props.location.state.dice.page) {
              pag = this.props.location.state.dice.page;
            } else {
              pag = state.page;
            }
            this.setState({ page: pag });
            this.page = pag;
            this.pageSize = state.pageSize;
            this.sorted = state.sorted;
            this.filtered = state.filtered;
            this.getCustomers();
          }}
        />
        {(showModalDelete
          && (
          <SweetAlert
            danger
            showCancel
            cancelBtnText={I18n.t('BEE99' /* Cancelar */)}
            confirmBtnText={I18n.t('BEE100' /* Confirmar */)}
            confirmBtnBsStyle="danger"
            cancelBtnBsStyle="default"
            title={I18n.t('BEE101' /* Você tem certeza? */)}
            onConfirm={() => this.deleteCustomer(customerUpdate)}
            onCancel={() => this.setInitState()}
          >
            {I18n.t('BEE314', { 0: customerUpdate.code } /* O cliente %{0} será eliminado! */)}
          </SweetAlert>
          )
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  customersList: state.customers && state.customers.customersList,
  formIntegrations: state.app.permissionsCompany && state.app.permissionsCompany.formIntegrations,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomersList: (tableParams) => dispatch(getCustomersList(tableParams)),
  deleteCustomer: (customerId) => dispatch(deleteCustomer(customerId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerList));
